import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.find.js";
export var getProductTransactionableOrganizations = function getProductTransactionableOrganizations(product) {
  var commercializations = product.commercializations;
  var commercializationsWithAffiliate = commercializations.filter(function (comm) {
    return comm.id && comm.affiliate && comm.affiliate.name && comm.relationship === 'distributor';
  });
  var uniqueIds = commercializationsWithAffiliate.map(function (item) {
    return item.organization.id;
  }).filter(function (value, index, self) {
    return self.indexOf(value) === index;
  });
  return uniqueIds.map(function (id) {
    return commercializationsWithAffiliate.find(function (item) {
      return item.organization.id === id;
    });
  }).map(function (commercialization) {
    return commercialization.organization;
  });
};